export const machinePublicPath = (token) => `/public/machine/${token}`;

export const articleFolderPublicPath = (token) =>
  `/public/dossiers_articles/dossiers_articles_details/${token}`;

/** Same public page as the printed QR, on the current origin (works on localhost). */
export const openPublicQrPage = (path) => {
  if (!path) {
    return;
  }
  window.open(`${window.location.origin}${path}`, '_blank', 'noopener,noreferrer');
};
